import {testIdProps} from '@github-ui/test-id-props'
import {useContainerBreakpoint} from '@github-ui/use-container-breakpoint'
import {useRef} from 'react'

import styles from './filter-container.module.css'

type FilterContainerProps = {
  /**
   * Optional label for the region landmark. When provided, the container
   * will have `role="region"` with this label. Omit to render without
   * a landmark role.
   */
  label?: string
}

/**
 * Renders a styled div for the `<TokenizedFilterInput />` component
 */
export function FilterContainer({label, children}: React.PropsWithChildren<FilterContainerProps>) {
  const filterContainerRef = useRef<HTMLDivElement>(null)

  // eslint-disable-next-line react-hooks/refs
  const breakpoint = useContainerBreakpoint(filterContainerRef.current)

  return (
    <div
      ref={filterContainerRef}
      role={label ? 'region' : undefined}
      aria-label={label}
      {...testIdProps('base-filter-input')}
      style={{
        flexWrap: breakpoint(['wrap', 'nowrap']),
        justifyContent: breakpoint(['flex-start', 'space-between']),
      }}
      className={styles.Box}
    >
      {children}
    </div>
  )
}

try{ FilterContainer.displayName ||= 'FilterContainer' } catch {}